import { fetchAuthSession } from "aws-amplify/auth";
import { AxiosInstance, default as Axios } from "axios";
import { PublicCredentials } from "../../auth/models/PublicCredentials";

let jwtAuthInstance: AxiosInstance | undefined;
let basicAuthInstance: AxiosInstance | undefined;

export const jwtAuthAxios = () => {
  if (!jwtAuthInstance) {
    jwtAuthInstance = newApiClientAuthInstance();
  }
  return jwtAuthInstance;
};

export const optionalAuthAxios = () => basicAuthInstance || jwtAuthAxios();

export const setPasswordAuthAxios = ({
  scope,
  scopeId,
  password,
}: PublicCredentials) => {
  basicAuthInstance = Axios.create({
    baseURL: `${process.env.REACT_APP_API}/public`,
  });
  const auth = `${scope}.${scopeId}:${password}`;
  basicAuthInstance.interceptors.request.use(async (configuration) => {
    configuration.headers!["Content-Type"] = "application/json";
    configuration.headers!.Authorization = `Basic ${btoa(auth)}`;
    return configuration;
  });
};

const newApiClientAuthInstance = () => {
  const instance = Axios.create({ baseURL: process.env.REACT_APP_API });

  instance.interceptors.request.use(async (configuration) => {
    configuration.headers!["Content-Type"] = "application/json";

    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;
    configuration.headers!.Authorization = `Bearer ${idToken}`;
    return configuration;
  });
  return instance;
};
